import Icon from '@ant-design/icons'
import * as React from 'react'

import { NovaIconProps } from '../types/iconTypes'

const Link = (props: NovaIconProps) => (
  <Icon
    {...props}
    component={() => (
      <svg
        width="1em"
        height="1em"
        focusable={false}
        viewBox="2 2 28 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.77817 13.2218C10.1687 12.8313 10.8019 12.8313 11.1924 13.2218C11.5829 13.6123 11.5829 14.2455 11.1924 14.636L8.01041 17.818C6.25305 19.5754 6.25305 22.4246 8.01041 24.182C9.76777 25.9393 12.617 25.9393 14.3744 24.182L17.5563 21C17.9469 20.6095 18.58 20.6095 18.9706 21C19.3611 21.3905 19.3611 22.0237 18.9706 22.4142L15.7886 25.5962C13.2502 28.1346 9.1346 28.1346 6.59619 25.5962C4.05779 23.0578 4.05779 18.9422 6.59619 16.4038L9.77817 13.2218ZM21.799 16.7574C21.4085 17.1479 21.4085 17.781 21.799 18.1716C22.1895 18.5621 22.8227 18.5621 23.2132 18.1716L26.3952 14.9896C28.9336 12.4512 28.9336 8.33561 26.3952 5.7972C23.8568 3.2588 19.7412 3.2588 17.2028 5.7972L14.0208 8.97918C13.6303 9.36971 13.6303 10.0029 14.0208 10.3934C14.4113 10.7839 15.0445 10.7839 15.435 10.3934L18.617 7.21142C20.3744 5.45406 23.2236 5.45406 24.981 7.21142C26.7383 8.96878 26.7383 11.818 24.981 13.5754L21.799 16.7574ZM12.4706 18.0295C12.08 18.42 12.08 19.0532 12.4706 19.4437C12.8611 19.8342 13.4943 19.8342 13.8848 19.4437L20.2487 13.0797C20.6393 12.6892 20.6393 12.0561 20.2487 11.6655C19.8582 11.275 19.2251 11.275 18.8345 11.6655L12.4706 18.0295Z"
          fill="currentColor"
        />
      </svg>
    )}
  />
)

export default Link
